module.exports = __webpack_public_path__ + "dafcc141d97f08d1d3d24324fbbb6a10.svg";